export class LetsBasketball {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.name = form.name; // 活动标题
      // this.activityCategory = form.activityCategory; // 活动类别
      // this.registrationType = form.registrationType; // 报名类型
      this.beginTime = form.beginTime; // 开始时间
      this.endTime = form.endTime; // 结束时间
      this.uaEventCityId = form.uaEventCityId; // 活动城市
      this.differDay = form.differDay; // 开放报名时间
      this.registrationIsOver = form.registrationIsOver; // 截止报名时间
      this.otherAddress = form.otherAddress; // 活动地址
      this.location =
        form.latitude && form.longitude
          ? `${form.latitude},${form.longitude}`
          : "0,0";
      this.activityTime = [form.beginTime, form.endTime]; // 活动日期
      // this.participationNumber = form.participationNumber; // 活动人数
      // this.alternateTotalNumber = form.alternateTotalNumber; // 候补人数
      this.maxTeam = form.maxTeam; // 最大团队数量
      this.minTeam = form.minTeam; // 最小团队数量
      this.isCalculationDuration = form.isCalculationDuration; // 计算活动时长
      this.isShow = form.isShow === 0 ? 0 : 1; // 是否在列表页展示0展示 1不展示
      // this.excelName = form.excelName; // 用户名单文件名
      // this.url = form.url; // 用户名单保存路径
      // this.file = form.file; // 用户名单文件
      // this.entryProcess = form.entryProcess;
      this.activityImageVO = form.activityImageVO || {};
    } else {
      this.clear();
    }
  }

  get activityTime() {
    if (this.beginTime && this.endTime) {
      return [this.beginTime, this.endTime];
    } else {
      return [];
    }
  }

  set activityTime(activityTime) {
    if (activityTime && Array.isArray(activityTime) && activityTime.length === 2) {
      this.beginTime = activityTime[0];
      this.endTime = activityTime[1];
    } else {
      this.beginTime = null;
      this.endTime = null;
    }
  }
  get location() {
    if (this.latitude && this.longitude) {
      return `${this.latitude},${this.longitude}`;
    } else {
      return "0,0";
    }
  }

  set location(location) {
    if (location) {
      this.latitude = location.split(",")[0];
      this.longitude = location.split(",")[1];
    } else {
      this.latitude = 0;
      this.longitude = 0;
    }
  }

  clear() {
    this.id = null;
    this.name = ''; // 活动标题
    // this.activityCategory = null; // 活动类别
    // this.registrationType = 0; // 报名类型
    this.beginTime = ''; // 开始时间
    this.endTime = ''; // 结束时间
    this.uaEventCityId = null; // 活动城市
    this.differDay = 14; // 开放报名时间
    this.registrationIsOver = 0; // 截止报名时间
    this.otherAddress = ''; // 活动地址
    this.location = "";
    this.activityTime = ''; // 活动日期
    // this.participationNumber = null; // 活动人数
    // this.alternateTotalNumber = null; // 候补人数
    this.isCalculationDuration = 1; // 计算活动时长
    this.maxTeam = null; // 最大团队数量
    this.minTeam = null; // 最小团队数量
    // this.excelName = ""; // 用户名单文件名
    // this.url = ""; // 用户名单保存路径
    // this.file = null; // 用户名单文件
    // this.entryProcess = ""; // 参赛流程
    this.isShow = 0;
    this.activityImageVO = {};
  }
}
